/* TCR GA4 funnel events. Rides the existing Google & YouTube app tag (G-L4BCE662TW).
   Loads sitewide, self-gates by path, sends nothing on other pages.
   Never sends personal data. Safe no-op if the Google tag is absent. */
(function () {
  'use strict';

  function send(name, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      function gtag() { window.dataLayer.push(arguments); }
      gtag('event', name, params || {});
    } catch (e) { /* tracking must never break the page */ }
  }

  /* Events that fire on page load must wait for the GA4 tag. Anything pushed
     before its config line is dropped, which is why quiz_complete only caught
     about 14% of result-page views in October. Checks for up to 10 seconds. */
  function sendWhenTagReady(name, params) {
    var tries = 0;
    (function check() {
      var gtm = window.google_tag_manager;
      if (gtm && gtm['G-L4BCE662TW']) {
        params = params || {};
        params.send_to = 'G-L4BCE662TW';
        send(name, params);
      } else if (tries++ < 50) {
        setTimeout(check, 200);
      }
    })();
  }

  var path = location.pathname;
  var handle = path.split('/').filter(Boolean).pop() || 'home';

  /* 0) Remember the ad's UTMs for this tab. The quiz saves utm_source, medium,
     campaign and content on the Klaviyo profile, but it only reads them from the
     quiz page's own URL. If someone lands on another page from an ad and then
     clicks through to the quiz, the UTMs are lost. This puts the last UTMs seen in
     this tab back on the quiz URL (without reloading) so the quiz still saves them. */
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
  try {
    var query = new URLSearchParams(location.search);
    var found = {};
    var hasUtm = false;
    for (var k = 0; k < UTM_KEYS.length; k++) {
      var v = query.get(UTM_KEYS[k]);
      if (v) { found[UTM_KEYS[k]] = v; hasUtm = true; }
    }
    if (hasUtm) {
      sessionStorage.setItem('tcr_utm', JSON.stringify(found));
    } else if (path.indexOf('/pages/starting-point-quiz') === 0) {
      var saved = JSON.parse(sessionStorage.getItem('tcr_utm') || 'null');
      if (saved) {
        for (var key in saved) query.set(key, saved[key]);
        history.replaceState(history.state, '', path + '?' + query.toString() + location.hash);
      }
    }
  } catch (e) { /* storage can be blocked; the quiz still works without it */ }

  /* 1) Quiz entry page: quiz_start fires once, on the first click INSIDE the
     reading-quiz widget itself (it is a shadow-DOM component, so the check uses
     the event's composed path). Clicks anywhere else on the page do not count. */
  if (path.indexOf('/pages/starting-point-quiz') === 0) {
    var started = false;
    document.addEventListener('click', function (e) {
      if (started) return;
      var inQuiz = false;
      var eventPath = e.composedPath ? e.composedPath() : null;
      if (eventPath) {
        for (var i = 0; i < eventPath.length; i++) {
          var n = eventPath[i];
          if (n && n.tagName === 'READING-QUIZ') { inQuiz = true; break; }
        }
      } else if (e.target && e.target.closest) {
        inQuiz = !!e.target.closest('reading-quiz');
      }
      if (!inQuiz) return;
      started = true;
      send('quiz_start', { page_handle: handle });
    }, true);

    /* quiz_step fires once per question reached in this visit (age, level or
       pronounce, remember, confidence, country) and once for the email screen
       (email_gate). Users per step = where parents drop off. generate_lead fires
       when the email form is submitted, the same moment the quiz sends Meta its
       Lead event, so GA4 leads line up with Meta and Klaviyo. This reads the
       quiz's own public state (cur, phase, answers) and does not change the quiz. */
    var watchTries = 0;
    (function watchQuiz() {
      var el = document.querySelector('reading-quiz');
      if (!el || !el.shadowRoot) {
        if (watchTries++ < 50) setTimeout(watchQuiz, 200);
        return;
      }
      var seen = {};
      var leadSent = false;
      function reportStep() {
        var step = el.phase === 'email' ? 'email_gate' : (el.phase === 'quiz' ? el.cur : null);
        if (!step || seen[step]) return;
        seen[step] = true;
        sendWhenTagReady('quiz_step', { quiz_step: step });
      }
      reportStep();
      new MutationObserver(reportStep).observe(el.shadowRoot, { childList: true, subtree: true });
      el.shadowRoot.addEventListener('submit', function () {
        if (leadSent) return;
        leadSent = true;
        var result = '';
        try {
          if (typeof window.computeResult === 'function') result = window.computeResult(el.answers) || '';
        } catch (e) { /* result stays blank */ }
        sendWhenTagReady('generate_lead', { lead_source: 'starting_point_quiz', quiz_result: result });
      }, true);
    })();
  }

  /* 2) Quiz outcome pages: quiz_complete on load (deterministic), kit CTA clicks. */
  var quizOutcomes = [
    'quiz-learn-sounds', 'quiz-ready-to-start', 'quiz-blending-words',
    'quiz-advanced-sounds', 'quiz-not-ready', 'quiz-advance-reader'
  ];
  if (quizOutcomes.indexOf(handle) > -1) {
    sendWhenTagReady('quiz_complete', { quiz_result: handle });
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href*="/products/"], a[href*="/collections/"], a[href*="/cart"]');
      if (!a) return;
      send('quiz_kit_cta_click', {
        quiz_result: handle,
        link_url: a.getAttribute('href') || '',
        link_text: (a.textContent || '').trim().slice(0, 80)
      });
    }, true);
  }

  /* 3) Webinar pages: play + email-gate submit.
     The workshop pages use Wistia's new player (the wistia-player element from
     fast.wistia.com/player.js), so bind that directly; the legacy _wq binding is
     kept as a fallback for any old-style embeds. The conversion event carries the
     email in its detail; it is deliberately NOT sent. Each event fires once per view. */
  var webinars = { 'toddler-workshop': 'toddler', 'kinder-workshop': 'kinder', 'older-workshop': 'older' };
  if (webinars[handle]) {
    var webinarName = webinars[handle];
    var sentPlay = false;
    var sentGate = false;

    function firePlay() {
      if (sentPlay) return;
      sentPlay = true;
      send('webinar_play', { webinar: webinarName });
    }
    function fireGate() {
      if (sentGate) return;
      sentGate = true;
      send('webinar_gate_submit', { webinar: webinarName });
    }

    function bindNewPlayer(p) {
      if (p.__tcrBound) return;
      p.__tcrBound = true;
      p.addEventListener('play', firePlay);
      p.addEventListener('conversion', fireGate);
    }
    function bindAllNewPlayers() {
      var found = document.querySelectorAll('wistia-player');
      for (var i = 0; i < found.length; i++) bindNewPlayer(found[i]);
    }
    bindAllNewPlayers();
    var tries = 0;
    var poll = setInterval(function () {
      bindAllNewPlayers();
      if (++tries > 15) clearInterval(poll);
    }, 2000);

    window._wq = window._wq || [];
    window._wq.push({
      id: '_all',
      onReady: function (video) {
        video.bind('play', firePlay);
        video.bind('conversion', fireGate);
      }
    });
  }

  /* 4) Homepage and link-in-bio router: which link do people actually tap. */
  if (path === '/' || path.indexOf('/pages/links') === 0) {
    var evName = (path === '/') ? 'home_link_click' : 'links_page_click';
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (href.charAt(0) === '#' || href.indexOf('javascript:') === 0) return;
      send(evName, {
        link_url: href,
        link_text: (a.textContent || '').trim().slice(0, 80)
      });
    }, true);
  }
})();